export default "__VITE_ASSET__pOwmzrSB__"